import "./Apartments.css";
import { Link } from "react-router-dom";

import {
  FaBed,
  FaBath,
  FaCouch,
  FaUtensils,
  FaInfoCircle,
  FaCalendarAlt,
  FaShieldAlt,
  FaCar,
  FaBuilding,
  FaLeaf,
} from "react-icons/fa";

import tipoA from "../assets/proyecto2.jpg";
import tipoB from "../assets/proyecto3.jpg";
import tipoC from "../assets/proyecto4.jpg";

/* ===========================
   INFORMACIÓN DE APARTAMENTOS
=========================== */

const apartments = [
  {
    id: 1,
    name: "Apartamento Tipo A",
    image: tipoA,
    area: "144.79 m²",
    price: "US$194,308",
    status: "Disponible",
    route: "/apartamentos/tipo-a",

    features: [
      {
        icon: <FaBed />,
        text: "3 Habitaciones",
      },
      {
        icon: <FaBath />,
        text: "4 Baños",
      },
      {
        icon: <FaCouch />,
        text: "Sala",
      },
      {
        icon: <FaUtensils />,
        text: "Comedor",
      },
    ],
  },

  {
    id: 2,
    name: "Apartamento Tipo B",
    image: tipoB,
    area: "129.67 m²",
    price: "US$174,017.14",
    status: "Disponible",
    route: "/apartamentos/tipo-b",

    features: [
      {
        icon: <FaBed />,
        text: "3 Habitaciones",
      },
      {
        icon: <FaBath />,
        text: "2.5 Baños",
      },
      {
        icon: <FaCouch />,
        text: "Sala",
      },
      {
        icon: <FaUtensils />,
        text: "Comedor",
      },
    ],
  },

  {
    id: 3,
    name: "Apartamento Tipo C",
    image: tipoC,
    area: "86.47 m²",
    price: "US$130,000",
    status: "Disponible",
    route: "/apartamentos/tipo-c",

    features: [
      {
        icon: <FaBed />,
        text: "2 Habitaciones",
      },
      {
        icon: <FaBath />,
        text: "2.5 Baños",
      },
      {
        icon: <FaCouch />,
        text: "Sala ",
      },
      {
        icon: <FaUtensils />,
        text: "Comedor",
      },
    ],
  },
];

/* ===========================
   BENEFICIOS DEL PROYECTO
=========================== */

const projectBenefits = [
  {
    id: 1,
    icon: <FaShieldAlt />,
    title: "Seguridad 24/7",
    text: "Tu tranquilidad es nuestra prioridad.",
  },

  {
    id: 2,
    icon: <FaCar />,
    title: "Parqueos techados",
    text: "Espacios cómodos para residentes y visitas.",
  },

  {
    id: 3,
    icon: <FaBuilding />,
    title: "Ascensor moderno",
    text: "Acceso cómodo y seguro a cada nivel.",
  },

  {
    id: 4,
    icon: <FaLeaf />,
    title: "Áreas verdes",
    text: "Espacios para disfrutar en familia.",
  },
];

/* ===========================
   COMPONENTE
=========================== */

function Apartments() {
  return (
    <section className="apartments" id="apartamentos">

      {/* TÍTULO PRINCIPAL */}

      <div className="apartments-heading">

        <span>ELIGE TU HOGAR IDEAL</span>

        <h2>Tipos de apartamentos</h2>

        <div className="apartments-heading-line"></div>

        <p>
          Espacios diseñados para tu comodidad, con distribuciones
          modernas, excelente iluminación y acabados de alta calidad.
        </p>

      </div>

      {/* TARJETAS DE APARTAMENTOS */}

      <div className="apartments-grid">

        {apartments.map((apartment) => (
          <article
            className="apartment-card"
            key={apartment.id}
          >

            {/* IMAGEN */}

            <div className="apartment-image-wrapper">

              <div className="apartment-status">
                <span></span>
                {apartment.status}
              </div>

              <img
                src={apartment.image}
                alt={`Plano de ${apartment.name}`}
                className="apartment-image"
              />

            </div>

            {/* INFORMACIÓN */}

            <div className="apartment-card-content">

              <div className="apartment-card-title-row">

                <h3>{apartment.name}</h3>

                <strong>{apartment.area}</strong>

              </div>

              <div className="apartment-card-accent"></div>

              <div className="apartment-price">
                {apartment.price}
              </div>

              {/* CARACTERÍSTICAS */}

              <div className="apartment-features">

                {apartment.features.map((feature, index) => (
                  <div
                    className="apartment-feature"
                    key={`${apartment.id}-${index}`}
                  >

                    <span className="apartment-feature-icon">
                      {feature.icon}
                    </span>

                    <span>{feature.text}</span>

                  </div>
                ))}

              </div>

              {/* BOTONES */}

              <div className="apartment-actions">

                <Link
                  to={apartment.route}
                  className="apartment-details-button"
                  aria-label={`Ver detalles de ${apartment.name}`}
                >
                  <FaInfoCircle />

                  <span>Ver detalles</span>
                </Link>

                <Link
                  to="/reserva"
                  className="apartment-reserve-button"
                  state={{
                    apartment: apartment.name,
                    price: apartment.price,
                    area: apartment.area,
                  }}
                  aria-label={`Reservar ${apartment.name}`}
                >
                  <FaCalendarAlt />

                  <span>Reservar</span>
                </Link>

              </div>

            </div>

          </article>
        ))}

      </div>

      {/* BENEFICIOS INFERIORES */}

      <div className="project-benefits">

        {projectBenefits.map((benefit) => (
          <div
            className="project-benefit"
            key={benefit.id}
          >

            <div className="project-benefit-icon">
              {benefit.icon}
            </div>

            <div className="project-benefit-content">

              <h4>{benefit.title}</h4>

              <p>{benefit.text}</p>

            </div>

          </div>
        ))}

      </div>

    </section>
  );
}

export default Apartments;